var CALCULATION_OPTIONS = {
  AUTOMATIC: 'AUTOMATIC',
  MANUAL: 'MANUAL'
};
export default CALCULATION_OPTIONS;